import { connect } from 'react-redux';
import { IUser } from '../../models';
import { IRootState } from '../../redux/state';
import OrderExclusionsAdmin from './OrderExclusionsAdmin';
import { bindActionCreators, Dispatch } from 'redux';
import { loadOrderExclusions } from '../../redux/modules/orderExclusions/orderExclusionsCreators';

function mapStateToProps(state: IRootState) {
  return {
    impersonatedUser: state.authentication.impersonatedUser,
    authentication: state.authentication as unknown as IUser,
    exclusions: state.orderExclusions.orderExclusions,
    isLoading: state.orderExclusions.isLoading,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getExclusions: loadOrderExclusions,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderExclusionsAdmin);
